import type { SVGProps } from 'react';
const SvgCloseSmallRedWithoutBg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      stroke="#ED131C"
      strokeLinecap="round"
      strokeWidth={2}
      d="M4.004 4.001 12.002 12M12 4l-7.998 7.998"
    />
  </svg>
);
export default SvgCloseSmallRedWithoutBg;
